// @flow
import { eventTypes, actionTypes, nodeTypes, targetUserTypes } from './trident-types';
import _ from 'lodash';

interface Option {
  key?: string;
  text: string;
  value: string;
}

interface NodeTypeChildOptions {
  [key: string]: string[];
}

interface FilterType {
  displayName: string;
  operators: Option[];
  type: any;
  options?: any;
}

interface DefaultFilterTypes {
  [key: string]: FilterType;
}

export const allowedOperators: Option[] = [
  { text: 'greater than or equal', value: 'ge' },
  { text: 'greater than', value: 'gt' },
  { text: 'equal to', value: 'eq' },
  { text: 'is a multiple of', value: 'im' },
];

export const nodesOccMapData = _.mapValues(nodeTypes, () => {
  return [];
});

export const OLD_BOOKING_EVENT_TYPES: string[] = ['onBookingComplete', 'onBookingConfirmed', 'onBookingCancelledDriver', 'onBookingCancelledPassenger', 'onBookingDroppingOff', 'onBookingDriverArrived', 'onUnsuccessfulReallocation'];

export const TridentResourceName = 'new_trident'; // the resource name in Boleh for trident campaign access
export const UcdCampaignResourceName = 'ucd_campaign'; // the resource name in Boleh for ucd campaign access
export const UcdProjectResourceName = 'ucd_project'; // the resource name in Boleh for ucd project access
export const UcdUniversalScope = 'ALL'; // the scope name in Boleh for ucd project access


export const TridentScopeNames = {
  userType: 'allowedUserTypes',
  owner: 'allowedOwners',
};

export const limitTypes = {
  perUser: 'user',
  perUserDaily: 'userDaily',
  total: 'total',
  totalDaily: 'totalDaily',
  perMerchant: 'merchant',
  perMerchantPerUser: 'merchantUser',
  dynamicValue: 'dynamicValue',
  dynamicValuePerUser: 'dynamicValuePerUser',
};

export const CampaignStatus = {
  draft: 'DRAFT',
  active: 'ACTIVE',
  inactive: 'INACTIVE',
  pending: 'PENDING',
};

export const SmartCampaignStatus = {
  draft: 'DRAFT',
  pending: 'PENDING',
  pendingAIP: 'PENDING-AIP',
  pendingCreation: 'PENDING-CREATION',
  active: 'ACTIVE',
  deactivated: 'DEACTIVATED',
};

export const statusList: Option[] = [
  { text: CampaignStatus.draft, value: CampaignStatus.draft },
  { text: CampaignStatus.active, value: CampaignStatus.active },
  { text: CampaignStatus.inactive, value: CampaignStatus.inactive },
  { text: CampaignStatus.pending, value: CampaignStatus.pending },
];

export const CampaignChangeType = {
  reject: 'rejectApproval',
  request: 'requestApproval',
  deactivate: 'deactivate',
  activate: 'activate',
  update: 'update',
  create: 'create',
};

export const targetTypeList: Option[] = [
  { text: 'PASSENGER', value: 'passenger' },
  { text: 'DRIVER', value: 'driver' },
  { text: 'FOODMAX', value: 'foodmax' },
  { text: 'TREATMENT', value: 'treatment' },
  { text: 'USERSERVICE', value: 'userservice' },
  { text: 'MOVEIT_PASSENGER', value: 'moveit_passenger' },
  { text: 'MOVEIT_DRIVER', value: 'moveit_driver' },
  { text: 'OVO', value: 'ovo' },
  { text: 'GENERIC_USER', value: 'generic_user' },
];

export const tridentUserVsUCDUser: Record<string, string> = {
  passenger: 'pax',
  driver: 'dax',
  foodmax: 'mex',
  userservice: 'mex',
};

export const defaultOwner: Option = { key: 'TARGETING', value: 'TARGETING', text: 'TARGETING' };
export const ownerQuest: Option = { key: 'quest', value: 'quest', text: 'QUEST' };
export const ownerPythia: Option = { key: 'pythia', value: 'pythia', text: 'pythia' };
export const ownerAds: Option = { key: 'ads', value: 'ads', text: 'ads' };

// owners that user can select on Omega
export const ownerTypeList: Option[] = [
  ownerQuest,
  defaultOwner,
];

export const PAYMENT_EVENTS: string[] = ['Payment Event 💸'];
export const BOOKING_EVENTS: string[] = ['Ride Event 🚙', 'Express Event 📦', 'Booking Event (deprecated)'];
export const QUEST_EVENTS: string[] = ['Ride Event 🚙', 'Payment Event 💸', 'Food Event 🍟', 'Express Event 📦'];

interface DeprecatedEventType {
  noun: string;
  eventType: string;
}

export const deprecatedBookingEventTypes: DeprecatedEventType[] = [
  { noun: 'On Booking Complete', eventType: 'onBookingComplete' },
  { noun: 'On Booking Confirmed', eventType: 'onBookingConfirmed' },
  { noun: 'On Booking Cancelled Driver', eventType: 'onBookingCancelledDriver' },
  { noun: 'On Booking Cancelled Passenger', eventType: 'onBookingCancelledPassenger' },
  { noun: 'On Booking Dropping Off', eventType: 'onBookingDroppingOff' },
];

export const deprecatedPaymentEventTypes: DeprecatedEventType[] = [
  { noun: 'On Payment Complete', eventType: 'onPaymentComplete' },
];


export const frequencyList: Option[] = [
  { text: 'targets_page.treatment_frequency_types.never', value: 'nr' },
  { text: 'targets_page.treatment_frequency_types.hour', value: 'hr' },
  { text: 'targets_page.treatment_frequency_types.day', value: 'da' },
  { text: 'targets_page.treatment_frequency_types.week', value: 'wk' },
  { text: 'targets_page.treatment_frequency_types.month', value: 'mt' },
];

const eqOp: Option = { key: 'eq', value: 'eq', text: 'is' };
const notEqOp: Option = { key: '!eq', value: '!eq', text: 'is not' };
const gteOp: Option = { key: 'gte', value: 'gte', text: 'greater than' };
const lteOp: Option = { key: 'lte', value: 'lte', text: 'less than' };
const matchOp: Option = { key: 'match', value: 'match', text: 'match' };
const inOp: Option = { key: 'in', value: 'in', text: 'in' };
const notInOp: Option = { key: '!in', value: '!in', text: 'not in' };

export const nodeTypeFilterOptions: Option[] = [
  { key: 'delay', value: 'delay', text: 'Delay' },
  { key: 'experiment', value: 'experiment', text: 'Experiment' },
  { key: 'count', value: 'count', text: 'Count' },
  { key: 'time', value: 'time', text: 'Time' },
];

export const defaultFilterTypes: DefaultFilterTypes = {
  name: {
    displayName: 'Name',
    operators: [matchOp],
    type: 'string',
  },
  rewardID: {
    displayName: 'Reward ID',
    operators: [eqOp, notEqOp, inOp, notInOp],
    type: 'number',
  },
  templateID: {
    displayName: 'Hedwig Template ID',
    operators: [eqOp, notEqOp],
    type: 'string',
  },
  bulkActionSegment: {
    displayName: 'Bulk Action Segment',
    operators: [eqOp, notEqOp, inOp, notInOp],
    type: 'string',
  },
  nodeType: {
    displayName: 'Node Type',
    operators: [eqOp, notEqOp],
    type: 'string',
    options: nodeTypeFilterOptions,
  },
  actionType: {
    displayName: 'Action Type',
    operators: [eqOp, notEqOp, inOp, notInOp],
    type: 'string',
    options: actionTypes,
  },
  eventType: {
    displayName: 'Event Type',
    operators: [eqOp, notEqOp, inOp, notInOp],
    type: 'string',
    options: eventTypes,
  },
  creator: {
    displayName: 'Creator',
    operators: [eqOp, notEqOp],
    type: 'string',
  },
  updater: {
    displayName: 'Last Updated By',
    operators: [eqOp, notEqOp],
    type: 'string',
  },
  startTime: {
    displayName: 'Start Time',
    operators: [gteOp, lteOp],
    type: 'date',
  },
  endTime: {
    displayName: 'End Time',
    operators: [gteOp, lteOp],
    type: 'date',
  },
  owner: {
    displayName: 'Owner',
    operators: [eqOp, notEqOp, inOp, notInOp],
    type: 'string',
    options: [defaultOwner, ownerQuest, ownerPythia, ownerAds],
  },
  ownerReferenceID: {
    displayName: 'Owner Reference ID',
    operators: [eqOp],
    type: 'string',
  },
  offerName: {
    displayName: 'Offer Name',
    operators: [matchOp],
    type: 'string',
  },
  offerTnc: {
    displayName: 'Offer T&Cs',
    operators: [matchOp],
    type: 'string',
  },
};

export const historyStatusOptions: Option[] = [
  { key: '', value: '', text: 'All' },
  { key: 'success', value: 'success', text: 'Action Success' },
  { key: 'rule-failed', value: 'rule-failed', text: 'Rule Evaluation Failed' },
  { key: 'action-failed', value: 'action-failed', text: 'Action Failed' },
];

export const timeEventFrequencyMap: Record<string, string> = {
  nr: 'No Repeat',
  hr: 'hour',
  da: 'day',
  wk: 'week',
  mt: 'month',
};

// action type to the template type in hedwig url
export const actionTypeToTemplateType: Record<string, string> = {
  sendInbox2: 'inbox',
  sendInbox2ToFamilyHost: 'inbox',
  sendPush: 'push',
  sendPushToFamilyHost: 'push',
  pushChainedInbox: 'pushinbox',
  pushChainedInboxToFamilyHost: 'pushinbox',
  sendEmail: 'email',
  bulkSendPush: 'push',
  bulkSendInbox: 'inbox',
  bulkPushChainedInbox: 'pushinbox',
  bulkSendEmail: 'email',
  bulkSendEmailByAddress: 'email',
  sendSMS: 'sms',
  bulkSendSMS: 'sms',
  sendWhatsapp: 'whatsapp',
  bulkSendWhatsapp: 'whatsapp',
  bulkSendLine: 'line',
  bulkSendZalo: 'zalo',
};

export const hedwigChannelToTridentBulkAction: Record<string, string> = {
  push: 'bulkSendPush',
  email: 'bulkSendEmail',
  inbox: 'bulkSendInbox',
  pushinbox: 'bulkPushChainedInbox',
  sms: 'bulkSendSMS',
};

export const convertTridentActionToHedwigChannel = (tridentAction: string): string | undefined => {
  return _.findKey(hedwigChannelToTridentBulkAction, (value) => value === tridentAction);
};

// user type to the segment type in segP url
export const userTypeToSegmentType: Record<string, string> = {
  passenger: 'PAX',
  driver: 'DAX',
  foodmax: 'MEX',
  moveit_passenger: 'PAX',
  moveit_driver: 'DAX',
  ovo: 'MEX',
};

export const countryIDToLocales: Record<number, string[]> = {
  1: ['ms', 'cn', 'en'], // Malaysia
  2: ['en'], // Philippines
  3: ['th', 'en'], // Thailand
  4: ['en'], // Singapore
  5: ['vn', 'en'], // Vietnam
  6: ['id', 'en'], // Indonesia
  8: ['en'], // United States
  9: ['mm', 'en'], // Myanmar
  10: ['kh', 'en'], // Cambodia
  77: ['zh-hant-tw', 'zh-Hant-TW', 'en'], // Taiwan. Keep lowercase legacy code for existing campaigns.
};

export const hedwigTemplateStatus = {
  active: 1,
  pendingApproval: 2,
  inactive: 3,
  draft: 4,
};

export const templateAppNameToUserTypes: Record<string, string[]> = {
  grab: ['passenger', 'driver', 'foodmax'],
  pax: ['passenger'],
  dax: ['driver'],
  mex: ['foodmax', 'userservice'],
  ovo: ['ovo'],
};

export const userTypeToTemplateAppName: Record<string, string> = {
  [targetUserTypes.pax]: 'pax',
  [targetUserTypes.moveITPax]: 'pax',
  [targetUserTypes.dax]: 'dax',
  [targetUserTypes.moveITDax]: 'dax',
  [targetUserTypes.mex]: 'mex',
  [targetUserTypes.userservice]: 'mex',
  [targetUserTypes.ovo]: 'ovo',
};

export const tridentCommActions: Record<string, string[]> = {
  SMS: ['sendSMS', 'bulkSendSMS'],
  Whatsapp: ['sendWhatsapp', 'bulkSendWhatsapp'],
  Line: ['bulkSendLine'],
};

const tmNodeTypeChildOptions: NodeTypeChildOptions = {
  [nodeTypes.condition]: [nodeTypes.actions],
  [nodeTypes.actions]: [],
};

const daxNodeTypeChildOptions: NodeTypeChildOptions = {
  [nodeTypes.time]: [nodeTypes.actions],
  [nodeTypes.count]: [nodeTypes.countCondition],
  [nodeTypes.countCondition]: [nodeTypes.delay, nodeTypes.actions, nodeTypes.randomizer],
  [nodeTypes.delay]: [nodeTypes.actions, nodeTypes.randomizer, nodeTypes.experiment],
  [nodeTypes.condition]: [nodeTypes.count, nodeTypes.delay, nodeTypes.actions, nodeTypes.randomizer],
  [nodeTypes.actions]: [],
  [nodeTypes.schedule]: [nodeTypes.enumeration],
  [nodeTypes.experiment]: [nodeTypes.experimentTreatment],
  [nodeTypes.experimentTreatment]: [nodeTypes.delay, nodeTypes.actions],
  [nodeTypes.enumeration]: [nodeTypes.actions, nodeTypes.experiment],
};

const userserviceNodeTypeChildOptions: NodeTypeChildOptions = {
  [nodeTypes.schedule]: [nodeTypes.enumeration],
  [nodeTypes.enumeration]: [nodeTypes.actions],
};

const paxNodeTypeChildOptions: NodeTypeChildOptions = {
  ...daxNodeTypeChildOptions,
  [nodeTypes.experiment]: [nodeTypes.experimentTreatment],
  [nodeTypes.experimentTreatment]: [nodeTypes.delay, nodeTypes.actions],
  [nodeTypes.enumeration]: [nodeTypes.actions, nodeTypes.experiment],
};

const mexNodeTypeChildOptions: NodeTypeChildOptions = {
  ...daxNodeTypeChildOptions,
  [nodeTypes.experiment]: [nodeTypes.experimentTreatment],
  [nodeTypes.experimentTreatment]: [nodeTypes.delay, nodeTypes.actions],
  [nodeTypes.enumeration]: [nodeTypes.actions], // keep MEX enumeration unchanged (no experiment under enumeration)
};

const moveITPaxNodeTypeChildOptions: NodeTypeChildOptions = {
  [nodeTypes.schedule]: [nodeTypes.enumeration],
  [nodeTypes.enumeration]: [nodeTypes.actions],
  [nodeTypes.actions]: [],
};

const moveITDaxNodeTypeChildOptions: NodeTypeChildOptions = {
  [nodeTypes.schedule]: [nodeTypes.enumeration],
  [nodeTypes.enumeration]: [nodeTypes.actions],
  [nodeTypes.actions]: [],
};

const ovoNodeTypeChildOptions: NodeTypeChildOptions = {
  [nodeTypes.schedule]: [nodeTypes.enumeration],
  [nodeTypes.enumeration]: [nodeTypes.actions],
  [nodeTypes.actions]: [],
};

export const nodeTypeChildOptions: Record<string, NodeTypeChildOptions> = {
  [targetUserTypes.pax]: paxNodeTypeChildOptions,
  [targetUserTypes.moveITPax]: moveITPaxNodeTypeChildOptions,
  [targetUserTypes.dax]: daxNodeTypeChildOptions,
  [targetUserTypes.moveITDax]: moveITDaxNodeTypeChildOptions,
  [targetUserTypes.mex]: mexNodeTypeChildOptions, // currently same as dax
  [targetUserTypes.treatment]: tmNodeTypeChildOptions,
  [targetUserTypes.userservice]: userserviceNodeTypeChildOptions,
  [targetUserTypes.ovo]: ovoNodeTypeChildOptions,
};

export const nodeTypeToAbbr: Record<string, string> = {
  [nodeTypes.actions]: 'A',
  [nodeTypes.scenarios]: 'S',
  [nodeTypes.condition]: 'C',
  [nodeTypes.count]: 'CT',
  [nodeTypes.countCondition]: 'CC',
  [nodeTypes.time]: 'T',
  [nodeTypes.delay]: 'D',
  [nodeTypes.experiment]: 'E',
  [nodeTypes.experimentTreatment]: 'ET',
  [nodeTypes.schedule]: 'SH',
  [nodeTypes.enumeration]: 'EN',
  [nodeTypes.randomizer]: 'R',
};

export const campaignStatus = {
  active: 'ACTIVE',
  inactive: 'INACTIVE',
  draft: 'DRAFT',
  pending: 'PENDING',
};

export const commsChannels = {
  push: 'Push',
  inbox: 'Inbox',
  email: 'Email',
  pushinbox: 'Push Chained Inbox',
  pciInbox: 'PCI - Inbox', // inbox channel in Push Chained Inbox
  pciPush: 'PCI - Push', // push channel in Push Chained Inbox
};

// channelStatsMapping: comms channel -> list of relevant engagement stats
export const channelStatsMapping: Record<string, string[]> = {
  [commsChannels.push]: ['triggered', 'sent', 'open'],
  [commsChannels.pushinbox]: ['triggered', 'sent', 'open', 'click'],
  [commsChannels.pciPush]: ['triggered', 'sent', 'open'],
  [commsChannels.pciInbox]: ['triggered', 'sent', 'open', 'click'],
  [commsChannels.inbox]: ['triggered', 'sent', 'open', 'click'],
  [commsChannels.email]: ['triggered', 'sent', 'delivered', 'open', 'click'],
};

// trackableCommsActions are the comms actions for which we have tracking metrics
export const trackableCommsActions: string[] = ['bulkPushChainedInbox', 'bulkSendInbox', 'sendPush', 'bulkSendEmail', 'sendEmail', 'sendInbox2', 'pushChainedInbox', 'bulkSendPush'];

export const defaultPurposeList: Option[] = [
  {
    key: '2:RPDemandGeneration',
    value: '2:RPDemandGeneration',
    text: 'Demand Generation',
  },
  {
    key: '3:RPBranding',
    value: '3:RPBranding',
    text: 'Branding',
  },
  {
    key: '4:RPPartnership',
    value: '4:RPPartnership',
    text: 'Partnership',
  },
  {
    key: '5:RPCommunications',
    value: '5:RPCommunications',
    text: 'Communications',
  },
  {
    key: '6:RPGrabPayAcquisition',
    value: '6:RPGrabPayAcquisition',
    text: 'GrabPay Acquisition',
  },
  {
    key: '7:RPGrabPayRetention',
    value: '7:RPGrabPayRetention',
    text: 'GrabPay Retention',
  },
  {
    key: '9:RPUndefined',
    value: '9:RPUndefined',
    text: 'Undefined',
  },
  {
    key: '10:RPAcquisition',
    value: '10:RPAcquisition',
    text: 'Acquisition',
  },
  {
    key: '11:RPRetention',
    value: '11:RPRetention',
    text: 'Retention',
  },
  {
    key: '12:RPAppeasement',
    value: '12:RPAppeasement',
    text: 'Appeasement',
  },
  {
    key: '13:RPGrabForBusiness',
    value: '13:RPGrabForBusiness',
    text: 'Grab For Business',
  },
  {
    key: '14:RPCorporateBilling',
    value: '14:RPCorporateBilling',
    text: 'Corporate Billing',
  },
  {
    key: '15:RPIncreaseSales',
    value: '15:RPIncreaseSales',
    text: 'Increase Sales',
  },
  {
    key: '16:RPIncreaseUniqueEaters',
    value: '16:RPIncreaseUniqueEaters',
    text: 'Increase Unique Eaters',
  },
  {
    key: '17:RPIncreaseEaters',
    value: '17:RPIncreaseEaters',
    text: 'Increase Eaters',
  },
  {
    key: '18:RPReactivateChurnEaters',
    value: '18:RPReactivateChurnEaters',
    text: 'Reactivate Churn Eaters',
  },
  {
    key: '19:RPSponsorship',
    value: '19:RPSponsorship',
    text: 'Sponsorship',
  },
  {
    key: '20:RPGMS',
    value: '20:RPGMS',
    text: 'GMS',
  },
];

export const defaultBudgetResourceList: Option[] = [
  {
    key: '0:RBUndefined',
    value: '0:RBUndefined',
    text: 'Undefined',
  },
  {
    key: '1:RBTransport',
    value: '1:RBTransport',
    text: 'Transport',
  },
  {
    key: '2:RBPayments',
    value: '2:RBPayments',
    text: 'Payments',
  },
  {
    key: '3:RBTransportPaymentsSplit',
    value: '3:RBTransportPaymentsSplit',
    text: 'Transport Payments Split',
  },
  {
    key: '6:RBGrabGifts',
    value: '6:RBGrabGifts',
    text: 'Grab Gifts',
  },
  {
    key: '9:RBFood',
    value: '9:RBFood',
    text: 'Food',
  },
  {
    key: '10:RBExpress',
    value: '10:RBExpress',
    text: 'Express',
  },
  {
    key: '12:RBBus',
    value: '12:RBBus',
    text: 'Bus',
  },
  {
    key: '13:RBWheels',
    value: '13:RBWheels',
    text: 'Wheels',
  },
  {
    key: '14:RBRewards',
    value: '14:RBRewards',
    text: 'Rewards',
  },
  {
    key: '15:RBAds',
    value: '15:RBAds',
    text: 'Ads',
  },
  {
    key: '17:RBMerchant',
    value: '17:RBMerchant',
    text: 'Merchant',
  },
  {
    key: '18:RBFoodPaymentSplit',
    value: '18:RBFoodPaymentSplit',
    text: 'Food Payment Split',
  },
  {
    key: '19:RBPaymentMerchantSplit',
    value: '19:RBPaymentMerchantSplit',
    text: 'Payment Merchant Split',
  },
  {
    key: '20:RBFoodMerchantSplit',
    value: '20:RBFoodMerchantSplit',
    text: 'Food Merchant Split',
  },
  {
    key: '21:RBCountrySupport',
    value: '21:RBCountrySupport',
    text: 'Country Support',
  },
  {
    key: '22:RBRegionalSupport',
    value: '22:RBRegionalSupport',
    text: 'Regional Support',
  },
  {
    key: '23:RBRegionalMarketingSupport',
    value: '23:RBRegionalMarketingSupport',
    text: 'Regional Marketing Support',
  },
  {
    key: '25:RBFinanceSplitPayment',
    value: '25:RBFinanceSplitPayment',
    text: 'Finance Split Payment',
  },
  {
    key: '26:RBGrabPlatformBusiness',
    value: '26:RBGrabPlatformBusiness',
    text: 'Grab Platform Business',
  },
  {
    key: '27:RBLending',
    value: '27:RBLending',
    text: 'Lending',
  },
];

export const countries: Record<number, string> = {
  1: 'Malaysia',
  2: 'Philippines',
  3: 'Thailand',
  4: 'Singapore',
  5: 'Vietnam',
  6: 'Indonesia',
  8: 'United States',
  9: 'Myanmar',
  10: 'Cambodia',
  77: 'Taiwan',
};

export const countriesCurrency: Record<number, string> = {
  1: 'RM',
  2: '₱',
  3: '฿',
  4: 'S$',
  5: '₫',
  6: 'Rp',
  8: '$',
  9: 'MMK',
  10: '៛',
  77: 'NT$',
};

export const CampaignBudgetSources = {
  newBiz: 'New Biz',
  paymentRetention: 'Payment Retention',
  paymentAcquisition: 'Payment Acquisition',
  oneGrabRetention: 'One Grab Retention',
  oneGrabAcquisition: 'One Grab Acquisition',
  martRetention: 'Mart Retention',
  martAcquisition: 'Mart Acquisition',
  foodRetention: 'Food Retention',
  foodAcquisition: 'Food Acquisition',
  transportRetention: 'Transport Retention',
  transportAcquisition: 'Transport Acquisition',
  expressRetention: 'Express Retention',
  expressAcquisition: 'Express Acquisition',
};

// when updating this value, also update Hedwig constant to keep in sync
// https://gitlab.myteksi.net/engineering/web-kit/-/blob/03a03a5c29882f54bf1d94e48e2190181142fb52/web-app/packages/hedwig-dash/constants/ucd.js#L18
export const CampaignTargetVerticals = {
  transport: 'Transport',
  food: 'Food',
  mart: 'Mart',
  express: 'Express',
  finance: 'Finance',
  oneGrab: 'One Grab',
  challenges: 'Challenges',
  gfb: 'GFB',
  kitchen: 'Kitchen',
  rentals: 'Rentals',
  rewards: 'Rewards',
  grabUnlimited: 'GrabUnlimited',
  omnicommerce: 'Omnicommerce',
  digitalGoods: 'Digital Goods (Pulsa & Bills)',
  brand: 'Brand',
};
